module.exports = __webpack_public_path__ + "img/checkbox-checked.7ac918f8.svg";